import React, { useContext, useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.component'
import { Row, Col, SpacerBase } from '../../atoms/GridSystem'
import Input from '../../atoms/Fields/Input/Input.component'
import * as S from './LeadForm.styles'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import Select from '../../atoms/Fields/Select/Select.component'
import { JOB_TITLE_DYNAMICS_MAP, PROVINCE_DYNAMICS_MAP, SECTOR_DYNAMICS_MAP } from './LeadForm.constants'

type LeadFormStep2Props = {
  withBackground?: boolean
}

const PROVINCE_KEYS = Object.keys(PROVINCE_DYNAMICS_MAP)
const JOB_TITLE_KEYS = Object.keys(JOB_TITLE_DYNAMICS_MAP)
const SECTOR_KEYS = Object.keys(SECTOR_DYNAMICS_MAP)

function LeadFormStep2({ withBackground }: LeadFormStep2Props) {
  const { selectedColorScheme } = useContext(SectionThemeContext)
  const t = useTranslations('leadForm.step2')

  const industryOptions = useMemo(() =>
    SECTOR_KEYS.map((key) => ({
      label: t(`industryOptions.${key}`),
      value: key,
    })),
  [t])

  const jobTitleOptions = useMemo(() =>
    JOB_TITLE_KEYS.map((key) => ({
      label: t(`jobTitleOptions.${key}`),
      value: key,
    })),
  [t])

  const provinceOptions = useMemo(() =>
    PROVINCE_KEYS.map((key) => ({
      label: t(`provinceOptions.${key}`),
      value: key,
    })),
  [t])

  return (
    <>
      <S.LeadFormStepTitleWrapper colorScheme={selectedColorScheme}>
        <Heading typo="headingXXL" as="h2" content={t('title')} />
        <Paragraph typo="paragraphMD" content={t('description')} />
      </S.LeadFormStepTitleWrapper>

      <Row>
        <Col xs={12} lg={3}>
          <S.FieldWrapper>
            <Input
              name="companyName"
              id="companyName"
              type="text"
              label={t('companyNameLabel')}
              required
              aria-required
              withFeedback={false}
              uppercase={false}
              password={false}
              withBackground={withBackground}
            />
          </S.FieldWrapper>
        </Col>
        <Col xs={12} lg={3}>
          <S.FieldWrapper>
            <Select
              name="province"
              id="province"
              label={t('provinceLabel')}
              options={provinceOptions}
              required
              withBackground={withBackground}
            />
          </S.FieldWrapper>
        </Col>
        <Col xs={12} lg={6}>
          <S.FieldWrapper>
            <Select
              name="jobTitle"
              id="jobTitle"
              label={t('jobTitleLabel')}
              options={jobTitleOptions}
              withBackground={withBackground}
            />
          </S.FieldWrapper>
        </Col>
      </Row>

      <Row>
        <Col xs={12} lg={6}>
          <S.FieldWrapper>
            <Select
              name="targetIndustry"
              id="targetIndustry"
              label={t('targetIndustryLabel')}
              helperText={t('targetIndustryHelper')}
              options={industryOptions}
              required
              withBackground={withBackground}
            />
          </S.FieldWrapper>
        </Col>
      </Row>
    </>
  )
}

export default LeadFormStep2
